export const EMAIL_PATTERN =
  '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

export const PASSWORD_PATTERN =
  '^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$';

export const NAME_PATTERN =
  "^[A-Za-zÁÉÍÓÚáéíóúÑñ]+(?:[ '-][A-Za-zÁÉÍÓÚáéíóúÑñ]+)*$";

export const ALPHA_NUMERIC_PATTERN = '^[a-zA-Z0-9]+$';
